import React from 'react';

export const Education = ({ data }) => {
  const renderEducation = (schools) => {
    return schools.map((school, i) => {
      return (
        <div key={`${school.name}-${i}`} className="col-md-12">
          {school.training ? renderTraining(school) : renderSchool(school)}
        </div>
      );
    });
  };

  const renderTraining = (cert) => {
    return (
      <section className="info">
        <h4 className='education'>{cert.name}</h4>
        <p className='description'>{cert.description}</p>
      </section>
    )
  }
const renderSchool = (school) => {
    return (
      <section className="info">
        <h4 className='education'>{school.name}</h4>

        <p>
          {school.degree} <span className="bullet">&bull;</span>
          <em><span className="date">{school.graduated}</span></em>
        </p>

        <p className='description'>{school.description}</p>
      </section>
    )
  }

  return (
    <div id="education">
      <div className="container">
        <div className="section-title text-center">
          <h2>Education</h2>
        </div>
        {data ? (
          <div>
            <div className="row section-info">
              <div className="col-md-3">
                <h3 className="header">Education</h3>
              </div>

              <div className="col-md-9">
                <div className="row item">
                  <div className="col-md-12">
                    {renderEducation(data.schools)}
                  </div>
                </div>
              </div>
            </div>
            <div className="row section-info">
              <div className="col-md-3">
                <h3 className="header">Certifications</h3>
              </div>

              <div className="col-md-9">
                <div className="row item">
                  <div className="col-md-12 education-items">
                    {renderEducation(data.certifications)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          'loading...'
        )}
      </div>
    </div>
  );
};
